import { api, type Note } from "../api/client";

export type LegacyNoteSaveOperations = {
  syncBody: typeof api.syncNoteText;
  rename: typeof api.renamePropagate;
  updateMetadata: typeof api.updateNote;
};

export async function saveLegacyNoteAuthorityFirst({
  noteId,
  baseline,
  title,
  body,
  tags,
  folderId,
  operations = {
    syncBody: api.syncNoteText,
    rename: api.renamePropagate,
    updateMetadata: api.updateNote
  }
}: {
  noteId: string;
  baseline: Note;
  title: string;
  body: string;
  tags: string[];
  folderId?: string;
  operations?: LegacyNoteSaveOperations;
}) {
  // The body-generation check is the irreversible gate. Do not rename,
  // propagate links, move, or retag until the server has accepted this body.
  const synced = await operations.syncBody(noteId, body, baseline.title);
  let note: Note = {
    ...baseline,
    body: synced.text,
    rev: synced.rev ?? baseline.rev
  };
  if (title !== baseline.title) {
    const renamed = await operations.rename(noteId, title);
    note = {
      ...note,
      ...renamed.note,
      body: synced.text,
      rev: renamed.note.rev ?? synced.rev ?? baseline.rev
    };
  }
  const tagsChanged = tags.join(",") !== (baseline.tags || []).join(",");
  const folderChanged = folderId !== baseline.folderId;
  if (tagsChanged || folderChanged) {
    const updated = await operations.updateMetadata(noteId, {
      tags,
      folderId
    });
    note = {
      ...note,
      ...updated.note,
      body: synced.text,
      rev: updated.note.rev ?? note.rev
    };
  }
  return {
    note: {
      ...note,
      title,
      body: synced.text,
      tags,
      folderId
    }
  };
}
